<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="售后工单详情" width="1200" @close="close">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane  :label="item.zendesk" :name="item.zendesk" v-for="(item,index) in dataList" :key="index">
          <el-form :inline="true"  class="" style="text-align: left">
            <div>报修信息</div>
            <div >
              <div class="flex flex-row-left flex-item-start">
                <el-form-item v-if="!isAll"  style="width:300px" label="维修sn号">
                  <div class="flex flex-row-left flex-item-start">
                    <div style="width: 200px">
                      <div  class="inputDiv" >
                        <input class="input" @change="isSave=true" v-model="item.snNumber" placeholder="请输入序列码"> <el-icon @click="getSnNumber()"><DocumentAdd /></el-icon>
                      </div>
                      <div style="color:#f56c6c" >请检查确认报修设备SN序列</div>
                    </div>
                    <div class="margin-0-10">
                      <el-button v-if="isSave" type="primary" size="small" @click="onSubmit">保存</el-button>
                    </div>
                  </div>

                </el-form-item>
                <el-form-item v-else style="width:300px" label="维修sn号">
                  <el-input style="width:200px"  v-model="item.snNumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="在保">
                  <el-checkbox v-model="item.isInDate" disabled></el-checkbox>
                </el-form-item>
                <el-form-item label="问题描述">
                  <el-input disabled
                            v-model="item.zendeskQuestion"
                            style="min-width: 240px"

                            :autosize="{ minRows: 2, maxRows: 8}"
                            type="textarea"
                            placeholder="Please input"
                  />
                </el-form-item>
              </div>
              <div>

                <el-form-item label="问题分类">
                  <el-input style="width:200px"  v-model="item.zendeskQuestionType" disabled></el-input>
                </el-form-item>
<!--                <el-form-item label="处理结论">-->
<!--                  <el-input style="width:200px" v-model="item.zendeskQuestionResults" disabled></el-input>-->
<!--                </el-form-item>-->


              </div>
              <div>
                <el-form-item label="客户图片">
                  <myImage class="margin-5-5" :key="indexs" v-for="(items,indexs) in item.zendeskPicList" :pictureUrl="items" :picture-url-list="item.zendeskPicList" :index="indexs"></myImage>
                </el-form-item>
              </div>
              <div>
                <el-form-item v-if="item.zendeskVidList?.sources.length>0" label="客户视频">
                  <vVideo ref="vVideo" class="margin-5-5"  :options="item.zendeskVidList">

                  </vVideo>
                </el-form-item>
                <el-form-item v-else label="客户视频">
                  暂未获取到客户视频
                </el-form-item>
              </div>
            </div>
            <div>重发信息</div>
            <div v-if="item.reSendNumber" >
              <el-form-item  label="发货订单号">
                <el-input style="width:200px" disabled v-model="item.reSendNumber" placeholder="请输入价格" clearable />
              </el-form-item>
              <el-form-item label="发货店铺">
                <el-input style="width:200px" disabled v-model="item.trackShopName" placeholder="请输入产品名称" clearable />
              </el-form-item>
              <el-form-item label="产品SKU">
                <el-input style="width:200px" disabled v-model="item.trackMaterSku" placeholder="请输入产品SKU" clearable />
              </el-form-item>
              <el-form-item  label="物流单号">
                <el-input style="width:200px" disabled v-model="item.trackNumber" placeholder="请输入物流单号" clearable />
              </el-form-item>
              <el-form-item  label="物流渠道">
                <el-input style="width:200px" disabled v-model="item.trackChannel" placeholder="请输入物流渠道" clearable />
              </el-form-item>
              <el-form-item  label="换货时间">
                <el-date-picker
                    disabled
                    value-format="YYYY-MM-DD HH:mm:ss"
                    format="YYYY-MM-DD HH:mm:ss"
                    v-model="item.trackDateTime"
                    type="datetime"
                    placeholder="换货时间"
                    clearable
                />
              </el-form-item>
            </div>
            <div class="margin-20-30"  v-else>
              暂未匹配到发货单号
            </div>
            <div>
              <div >退机信息</div>
              <div >
                <el-form-item   label="物流单号">
                  <el-input disabled style="width:200px" v-model="item.receiveNumber" placeholder="请输入物流单号" clearable />
                </el-form-item>
                <el-form-item label="物流渠道">
                  <el-input style="width:200px" disabled v-model="item.receiveChannel" placeholder="请输入物流渠道" clearable />
                </el-form-item>
                <el-form-item label="退回仓库">
                  <el-input style="width:200px"  disabled v-model="item.receiveWarehouse" clearable/>
                </el-form-item>
                <el-form-item label="产品SKU">
                  <el-input style="width:200px" disabled v-model="item.receiveMaterSku" placeholder="请输入产品SKU" clearable />
                </el-form-item>
                <el-form-item label="产品名称">
                  <el-input style="width:200px" disabled v-model="item.receiveMaterName" placeholder="请输入产品名称" clearable />
                </el-form-item>
                <el-form-item label="退回备注">
                  <el-input style="width:200px" disabled v-model="item.receiveRemarks" clearable />
                </el-form-item>
                <el-form-item  label="退货入库时间">
                  <el-date-picker
                      disabled
                      style="width:200px"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      format="YYYY-MM-DD HH:mm:ss"
                      v-model="item.receiveDate"
                      type="datetime"
                      placeholder="退货入库时间"
                      clearable
                  />
                </el-form-item>
                <el-form-item label="物流状态">
                  <el-select
                      @clear="formInline.receiveStatus=''"
                      disabled
                      style="width:200px"
                      v-model="item.receiveStatus"
                      clearable
                      placeholder="请选择物流状态"
                  >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>

            </div>
          </el-form>
        </el-tab-pane>
        <div v-if="dataList.length==0">
          {{notice}}
        </div>
        <input hidden type="file" @change="handleFileChange" ref="fileInput" />
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElDatePicker,
  ElTabs,
  ElTabPane,
  ElCheckbox,
  ElSelect,
  ElOption,
  ElButton,
  ElMessage, ElIcon
} from "element-plus";
import myImage from "@/components/myImage.vue"
import vVideo from "@/components/video.vue"
import http, {uploadUrl} from "@/utils/requset";

export default {
  name: "activeSaleInfo",
  components:{
    ElDialog,ElForm,ElFormItem,ElInput,ElDatePicker,myImage,ElTabs,ElTabPane,ElCheckbox,ElSelect,ElOption,ElButton,vVideo,ElIcon
  },
  data(){
    return{
      isAll:false,
      dialogTableVisible:false,
      dataList:[],
      activeName:'',
      isSave:false,
      uploadUrl:'',
      notice:"匹配工单中，请稍后",
      options : [
        {
          value: '待发货',
          label: '待发货',
        },
        {
          value: '已发货',
          label: '已发货',
        },
        {
          value: '已签收',
          label: '已签收',
        }
      ],
      "instore":[
        {
          value: '自然损耗',
          label: '自然损耗',
        },
        {
          value: '维修',
          label: '维修',
        }
      ]

    }
  },
  beforeMount() {
    this.uploadUrl = uploadUrl
  },
  methods:{
    open(data){
      this.isSave = false
      this.dialogTableVisible = true;
      if(data.id){
        this.getSaleInfo({saleOrder:data.id})
        this.isAll = false
      }else if(data.sn_log_id){
        this.getSaleInfo({snLogId:data.sn_log_id})
        this.isAll = true
      }else{
        this.dialogTableVisible = false;
        ElMessage.error('传入参数错误')
      }
    },
    getSaleInfo(option){
      http.get('/after/afterSaleInfo',option).then(res=>{
        console.log(res)
        this.dataList = res.Data.map((item)=>{
          return {
            ...item,
            zendeskVidList:{
              autoplay: false,
              controls: true,
              sources: item.zendeskVidList.map(item=>{
                return  {
                  src: item,
                  type: 'video/mp4'}
              })
            }
          }
        })
        if(this.dataList.length){
          this.activeName = this.dataList[0].zendesk
        }else{
          this.notice = "暂未找到匹配zendesk工单"
        }
        console.log(this.dataList)
      }).catch(err=>{
        console.log(err)
      })
    },
    handleClick(tab,event){
      this.activeName =  tab.props.name
      console.log(event)
    },
    onSubmit(){
      let data = this.dataList.filter((item)=>{
        return  item.zendesk ==this.activeName
      })
      console.log(data[0])
      http.post('/after/updateAfterSaleInfo',{id:data[0].id,'snNumber':data[0].snNumber}).then(res=>{
        console.log(res)
        ElMessage.success('修改成功')
        //this.dialogTableVisible = false
        //this.$emit('closeEdit')
      }).catch(err=>{
        console.log(err)
      })
    },
    getSnNumber(){
      this.$refs.fileInput.click()
    },
    close(){
      let data = this.dataList.filter((item)=>{
        return  item.zendesk ==this.activeName
      })
      if (data.zendeskVidList?.sources.length>0){
        this.$refs.vVideo.destroyPlayer()
      }

      this.dialogTableVisible = false
    },
    handleFileChange(event){
      const file = event.target.files[0]; // 获取第一个文件
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error('图片上传大小不超过8M!')
        return false
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('isSn',true);
      http.post(uploadUrl,formData, {}).then(res=>{
        let data = this.dataList.filter((item)=>{
          return  item.zendesk ==this.activeName
        })
        this.isSave = true
        data[0].snNumber = res.data
        event.target.value = ''
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
  border: 1px #999999 dashed;
}
.inputDiv{
  width:178px;
  align-items: center;
  background-color: var(--el-input-bg-color, var(--el-fill-color-blank));
  background-image: none;
  border-radius: var(--el-input-border-radius, var(--el-border-radius-base));
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color));
  cursor: text;
  display: inline-flex;
  flex-grow: 1;
  justify-content: center;
  padding: 1px 11px;
  transform: translateZ(0);
  transition: var(--el-transition-box-shadow);
}
.input{
  width: 178px;
  -webkit-appearance: none;
  background: none;
  border: none;
  box-sizing: border-box;
  color: var(--el-input-text-color, var(--el-text-color-regular));
  flex-grow: 1;
  font-size: inherit;
  height: var(--el-input-inner-height);
  line-height: var(--el-input-inner-height);
  outline: none;
  padding: 0;
}
</style>